import { toBaseStudyEntity } from './study-entity.js';
import { StudyEntityType } from './study-entity-type.js';
export const populationNameMaxLength = 120;
export const populationSizeMaxValue = 10000000;
export function toStudyPopulation(studyPopulation) {
    return {
        ...toBaseStudyEntity(studyPopulation, StudyEntityType.StudyPopulation),
        name: studyPopulation.name,
        size: studyPopulation.size,
    };
}
//# sourceMappingURL=study-population.js.map